export var TOOLBAR_BORDER_WIDTH = 2;
